export default new class LocalizationManager {

    constructor() {
        this.currantLanguage = 'en';
        this.localizationChangedCallbacs = [];
        this.textFields = [];
        this.images = [];
        this.vars = [];
    }

    init() {
        this.localization = PIXI.Loader.shared.resources['Localization'].data;
    }

    changeLocalization(localization) {
        this.currantLanguage = localization;

        this.textFields.forEach((item) => {
            this.setTranslatedText(item)
        });

        this.images.forEach((item, index) => {
            if (!item.image.parent) {
                this.images.splice(index, 1)
            } else {
                this.setTranslatedImage(item)
            }
        });

        /*this.vars.forEach((item) => {
            item.item = Helper.translate(item.identificator);
        });*/

        this.localizationChangedCallbacs.forEach((callbackData) => {
            callbackData.function.call(callbackData.context, this.currantLanguage);
        })
    }

    addTextField(textField, identificator, params) {
        let item = {
            textField: textField,
            identificator: identificator ? identificator : textField.name,
            params: params,
            baseStyle: Object.assign({}, textField.style),
            basePosition: Object.assign({}, textField.position)
        };
        this.setTranslatedText(item);

        let index = this.getTextFieldIndex(textField);
        if (index === -1) {
            this.textFields.push(item);
        } else {
            this.textFields[index] = item;
        }
    }

    setTranslatedText(item) {
        if (!this.localization) {
            return;
        }

        let text = '';//item.identificator;
        if (item.textField && !item.textField._destroyed && this.localization[item.identificator]) {
            //item.textField.text = Helper.translate(item.identificator, item.params);
            text = this.getLocalizedText(item.identificator, item.params);
        }
        if (text !== ''){
            item.textField.text = text;
        }

        /*let baseFont = item.baseStyle['_fontSize']
        item.textField.y = item.basePosition['_y']
        item.textField.style.fontSize = baseFont
        while(item.textField.origWidth > item.textField.width) {
          item.textField.style.fontSize--
          //item.textField.y += 0.6
        }
        item.textField.correctPosition()*/
    }

    getLocalizedText(identificator, params) {
        if (!this.localization) {
            return;
        }
        let text = this.localization[identificator] || identificator;
        if (params) {
            params.forEach((param, index)=>{
                text = text.replace(`{${index}}`, param);
            });
        }

        return text;
    }

    getTextFieldIndex(textField) {
        return this.textFields.findIndex((element) => {
            return element.textField === textField;
        })
    }

    removeTextField(textField) {
        let index = this.getTextFieldIndex(textField);
        if(index !== -1) {
            this.textFields.splice(index, 1);
        }
    }

    addLocalizationChangedCallback(callback, context) {
        this.localizationChangedCallbacs.push({function: callback, context: context});
    }

    /*addVar(itemText, identificator) {
        let item = {item: itemText, identificator: identificator};
        item.item = Helper.translate(item.identificator);
        this.vars.push(item);
    }*/

    addImage(image, baseName) {
        let item = {image: image, baseName: baseName};
        this.setTranslatedImage(item);
        this.images.push(item);
    }

    setTranslatedImage(item) {
        let lang = 'en';
        let name = item.baseName;
        switch (lang) {
            case 'en':
                name = item.baseName;
                break;
            case 'tr':
                name = item.baseName + '_' + lang;
                break;
            default:
                name = item.baseName;
                break
        }
        item.image.texture = PIXI.Texture.fromImage(name);
    }

}
